import { render, staticRenderFns } from "./otherFilePreview.vue?vue&type=template&id=c704df8a"
import script from "./otherFilePreview.vue?vue&type=script&lang=js"
export * from "./otherFilePreview.vue?vue&type=script&lang=js"
import style0 from "./otherFilePreview.vue?vue&type=style&index=0&id=c704df8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports